var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ODatepicker',_vm._b({ref:"datepicker",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},'ODatepicker',Object.assign({}, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }